import { addError } from '@infra/datadog/tracking';
import { DeviceIdService } from '@services/DeviceIdService';
import createClient from 'openapi-fetch';
import type { paths, components } from '@api/play-account/generated';

import { ApiError } from '@libs/errors';

import { AuthService } from '@features/auth/services/AuthService';

export { components, paths };

const NAME = 'AccountApi';
const BASE_URL = __RUNTIME.accountApi;

const api = createClient<paths>({
  baseUrl: BASE_URL,
});

api.use({
  async onRequest({ request }) {
    request.headers.set('X-Device-Id', DeviceIdService.instance.id);

    // SEE: https://openapi-ts.dev/openapi-fetch/middleware-auth
    if (AuthService.instance.accessToken) {
      request.headers.set('Authorization', `Bearer ${AuthService.instance.accessToken}`);
    }
    return request;
  },

  async onResponse({ response }) {
    if (response.status === 401) {
      // sic! если токен есть — он невалидный и надо его стереть
      AuthService.instance.deleteTokens();
    }

    if (response.status >= 400) {
      const err = await ApiError.fromResponse(NAME, response);
      throw err;
    }
  },

  onError({ error, request }) {
    const err = ApiError.fromRequestError(NAME, request, error);
    addError(err);
    throw err;
  },
});

const { GET, POST, DELETE } = api;
export { GET, POST, DELETE };
